import {Button, Popconfirm, Tooltip} from "antd";
import {useContext} from "react";
import {VeriflytRegistererContext} from "./context";
import {ButtonProps} from "antd/lib/button";

export function RegisterVeriflytAccountButton(props: ButtonProps){

    const context = useContext(VeriflytRegistererContext);

    if (!context?.accountRegistrar){
        return <Button type="danger" disabled>Context not found</Button>;
    }

    const btnProps: ButtonProps = {
        disabled: context.accountRegistrar.isRegistering || !context.accountRegistrar.isValid,
        ...props
    }

    return <Popconfirm
        title="Please confirm. This action cannot be undone!"
        okText="Yes, Register"
        cancelText="Cancel"
        onConfirm={context.accountRegistrar.registerAuto}
        okButtonProps={{
            type: 'danger'
        }}
    >
        <Button {...btnProps}>
            Generate Veriflyt ID & Register
        </Button>
    </Popconfirm>
}